export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10371.f464f703.jpg";